module.exports = __webpack_public_path__ + "img/input-bg.74848a1d.png";